import { IOption } from '@isdd/idsk-ui-kit/index'
import { CREATE_RELATION_TYPE_BLACKLIST } from '@isdd/metais-common/api'
import { RelatedCiTypePreview, RelationshipType } from '@isdd/metais-common/api/generated/types-repo-swagger'
import { TFunction } from 'i18next'
import { includes } from 'lodash'
import { GroupBase } from 'react-select'

type CreateSelectRelationTypeOptionsProps = {
    relatedListAsSources: RelatedCiTypePreview[] | undefined
    relatedListAsTargets: RelatedCiTypePreview[] | undefined
    t: TFunction<'translation', undefined, 'translation'>
}

type SimpleSelectRelationTypeOptionsProps = {
    relatedList: RelationshipType[] | undefined
}

export enum SELECT_REL_TYPE_GROUP {
    source = 'source',
    target = 'target',
}

export const createSelectRelationTypeOptions = ({ relatedListAsSources, relatedListAsTargets, t }: CreateSelectRelationTypeOptionsProps) => {
    const sourceArray: GroupBase<IOption<string>> = {
        label: t('newRelation.selectSource'),
        options: relatedListAsTargets
            ?.map((item) => ({
                label: item.relationshipTypeName ?? '',
                value: item.relationshipTypeTechnicalName ?? '',
                group: SELECT_REL_TYPE_GROUP.source,
            }))
            .filter((rel) => !includes(CREATE_RELATION_TYPE_BLACKLIST, rel.value)) as IOption<string>[],
    }

    const targetArray: GroupBase<IOption<string>> = {
        label: t('newRelation.selectTarget'),
        options: relatedListAsSources
            ?.map((item) => ({
                label: item.relationshipTypeName ?? '',
                value: item.relationshipTypeTechnicalName ?? '',
                group: SELECT_REL_TYPE_GROUP.target,
            }))
            .filter((rel) => !includes(CREATE_RELATION_TYPE_BLACKLIST, rel.value)) as IOption<string>[],
    }

    return [sourceArray, targetArray]
}

export const createSimpleSelectRelationTypeOptions = ({ relatedList }: SimpleSelectRelationTypeOptionsProps) =>
    relatedList?.map((item) => ({ label: item.name ?? '', value: item.technicalName ?? '' })) ?? []

export const filterRelatedList = (list: RelatedCiTypePreview[] | undefined, tabName: string | string[]) => {
    return (
        list?.filter((item) =>
            Array.isArray(tabName)
                ? tabName.includes(item.ciTypeTechnicalName ?? '')
                : tabName === item.ciTypeTechnicalName &&
                  item.ciTypeValid &&
                  item.relationshipTypeValid &&
                  (item.ciCategory != 'NO' || item.relationshipCategory != 'NO') &&
                  (item.ciTypeUsageType != 'system' || item.relationshipTypeUsageType != 'system'),
        ) ?? []
    )
}

export const filterRelatedListByRelType = (list: RelatedCiTypePreview[] | undefined, technicalNames: string[]) => {
    return (
        list?.filter(
            (item) =>
                item.relationshipTypeTechnicalName &&
                technicalNames.includes(item.relationshipTypeTechnicalName) &&
                item.ciTypeValid &&
                item.relationshipTypeValid &&
                (item.ciCategory != 'NO' || item.relationshipCategory != 'NO') &&
                (item.ciTypeUsageType != 'system' || item.relationshipTypeUsageType != 'system'),
        ) ?? []
    )
}

export const findRelationType = (relTechnicalName: string, relationsList: RelatedCiTypePreview[]) => {
    const relationType = relationsList.find((rel) => rel.relationshipTypeTechnicalName === relTechnicalName)
    return relationType
}
